<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div class="chromosome-shell">
  <div #host class="pixi-host"></div>

  <div #hScroller class="proxy-scroll proxy-scroll-x">
    <div #hSpacer class="proxy-spacer-x"></div>
  </div>

  <div #vScroller class="proxy-scroll proxy-scroll-y">
    <div #vSpacer class="proxy-spacer-y"></div>
  </div>

  <div class="proxy-scroll-corner"></div>
</div>